import { useContactFormStore } from './ContactFormStore';

export function useContactFormState() {
  const isOpen = useContactFormStore((state) => state.isOpen);
  const contactFormSlug = useContactFormStore((state) => state.contactFormSlug);
  const openedThrough = useContactFormStore((state) => state.openedThrough);
  const source = useContactFormStore((state) => state.source);
  const previouslyFocusedElement = useContactFormStore((state) => state.previouslyFocusedElement);
  const setOpenedThrough = useContactFormStore((state) => state.setOpenedThrough);
  const openContactForm = useContactFormStore((state) => state.openContactForm);
  const closeContactForm = useContactFormStore((state) => state.closeContactForm);

  return {
    isOpen,
    contactFormSlug,
    openedThrough,
    source,
    previouslyFocusedElement,
    setOpenedThrough,
    openContactForm,
    closeContactForm,
  };
}
